import type { FlightLeg } from '../../domain/types'

export function hasUrl(url: string): boolean {
  return url.trim().length > 0
}

export function hasFlightAirlineServicesContent(
  legs: FlightLeg[],
  airlineBaggageFaqUrl?: string,
): boolean {
  const hasBaggageFaq = hasUrl(airlineBaggageFaqUrl ?? '')

  return hasBaggageFaq
    || legs.some(leg => hasUrl(leg.airlineCheckInURL))
    || legs.some(leg => hasUrl(leg.airlineSeatReservationURL))
}

export function getDistinctAirlineNames(legs: FlightLeg[]): string[] {
  return Array.from(
    new Set(
      legs
        .map(leg => leg.airlineName.trim())
        .filter(Boolean),
    ),
  )
}

export function formatAirlineServicesTitle(
  baseTitle: string,
  distinctAirlineNames: string[],
): string {
  if (distinctAirlineNames.length === 1) {
    return `${baseTitle} ${distinctAirlineNames[0]}`
  }

  return baseTitle
}

export function buildAirlineServiceLabel(
  baseLabel: string,
  leg: FlightLeg,
  hasMultipleLegs: boolean,
): string {
  if (!hasMultipleLegs) {
    return baseLabel
  }

  return `${baseLabel} – ${leg.airlineName} (${leg.flightNumber})`
}
